export default "__VITE_ASSET__DmnYid3H__"